import type { Step, StreamStep } from "../types";

/**
 * What the agent did to reach an answer, behind "Cum am verificat".
 *
 * An advocate deciding whether to trust a citation wants to know what was
 * looked for, not only what came back: "it never searched for concediere"
 * and "it searched and retrieval missed" are different problems with
 * different remedies, and only the first is visible from the answer.
 *
 * The toggle sits at the top of the answer, where the live list was; this
 * is only the list.
 */
export function StepList({ steps }: { steps: Step[] }) {
  if (!steps.length) return null;
  return (
    <ol className="steps">
      {steps.map((s, i) => (
        <li key={`${s.tool}-${i}`}>
          <i className="dot" aria-hidden="true" />
          <span>
            <span className="steps-label">{s.label}</span>
            {s.detail && <span className="steps-detail"> · {s.detail}</span>}
          </span>
        </li>
      ))}
    </ol>
  );
}

/**
 * The step happening now, on one row, with a light passing over it to show
 * the work is still going. One row rather than the growing list: the lawyer
 * waiting needs to see that something is happening and roughly what, and
 * the full list is one click away under the answer ("Cum am verificat").
 *
 * Between two steps - the model reading what came back and choosing what to
 * do, or writing the answer - the row says so instead of repeating a search
 * that has finished.
 */
export function LiveSteps({ steps }: { steps: StreamStep[] }) {
  const now = steps[steps.length - 1];
  const label = !now
    ? "Pregătesc căutarea"
    : now.status === "done"
      ? "Analizez ce am găsit"
      : now.label;
  const detail = now && now.status !== "done" ? now.detail : null;
  return (
    <div className="a thinking" aria-live="polite">
      {/* Keyed by what it says, so each new step fades in. */}
      <div className="live-step" key={`${now?.id ?? 0}-${now?.status ?? ""}`}>
        <span className="shimmer">
          {label}
          {detail ? ` · ${detail}` : "…"}
        </span>
      </div>
    </div>
  );
}
